import { render, staticRenderFns } from "./PeriodView.vue?vue&type=template&id=1fa5130a&scoped=true"
import script from "./PeriodView.vue?vue&type=script&lang=js"
export * from "./PeriodView.vue?vue&type=script&lang=js"
import style0 from "./PeriodView.vue?vue&type=style&index=0&id=1fa5130a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa5130a",
  null
  
)

export default component.exports